export default __webpack_public_path__ + "static/1-4088ee9803fe493724a9c8ef547a8c06.jpeg";